























































import { defineComponent, computed, PropType } from '@vue/composition-api';
import { CurrencyOption } from './../../../../hooks/creation/account/useCurrencyOption/index';
import { XInputNumber } from '@okee-uikit/web-components-vue';
const name = 'ttam-bid-strategy-set';

export default defineComponent({
  name,
  components: {
    XInputNumber,
  },
  props: {
    value: {
      type: [String, Number],
      required: true,
    },
    inputType: {
      type: String,
      default: 'number',
    },
    title: {
      type: String,
      default: '',
    },
    currencyUnit: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    dataKey: {
      type: String,
      default: '',
    },
    clickKey: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    currencyOption: {
      type: Object as PropType<CurrencyOption>,
      default: () => ({}),
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    showEmptyPlaceholder: {
      type: Boolean,
      default: false,
    },
    validateStatus: {
      type: String,
      default: 'default',
    },
  },
  setup(props, { emit }) {
    const _value = computed({
      get: () => props.value,
      set: v => {
        emit('change', v, props.dataKey);
        emit('input', v, props.dataKey);
      },
    });

    const hangleMouseEnter = () => {
      emit('toolTipsDisable', true);
    };
    const hangleMouseLeave = () => {
      emit('toolTipsDisable', false);
    };
    const handleBlur = () => {
      emit('handleBlur');
    };

    return {
      name,
      _value,
      hangleMouseEnter,
      hangleMouseLeave,
      handleBlur,
    };
  },
});
